<template>
  <div class="medical-detail-cntainer">
    <TopBg title="关于我们" sub-title="数智化解决方案商" :bg="topBg" />
    <div class="main-content page">
      <div class="section">
        <div class="title" id="intro">企业简介</div>
        <div class="rows-3">
          <about-item title="愿景" value="行业领先的数智化解决方案商">
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" :width="icon" :height="icon" viewBox="0 0 64 64" fill="none">
                <path
                  d="M57.5606 5.55028C57.5606 3.92286 56.0072 4.32972 55.5264 4.81055C54.6017 5.80919 52.1606 7.84346 46.9454 8.91608C46.1317 9.10102 45.355 9.17499 44.5413 9.17499C42.0262 9.17499 39.9179 8.36128 37.5138 7.39962C34.7398 6.327 31.5959 5.10644 27.3054 5.10644C26.9356 5.10644 26.5657 5.10644 26.1958 5.14343C21.5355 5.36535 17.5039 7.39962 14.582 8.91608C13.7241 9.34572 12.861 9.76494 11.9929 10.1736L11.734 9.54486L11.697 9.50787C11.2901 8.54621 10.1805 8.10237 9.21889 8.50923C8.77505 8.69416 8.40518 9.06403 8.22024 9.54486C8.03531 9.9887 8.03531 10.5435 8.22024 10.9873L27.4904 56.6291C27.7863 57.3318 28.452 57.7757 29.2288 57.7757C29.4877 57.7757 29.7466 57.7387 29.9685 57.6277C30.9301 57.2209 31.374 56.1113 30.9671 55.1496L24.3835 39.5412C25.2342 38.1357 27.1205 35.7685 30.7452 34.7699C31.8918 34.474 33.0754 34.289 34.3699 34.289C36.848 34.289 39.2522 34.8438 41.8043 35.4356C44.1344 35.9534 46.5016 36.5082 48.8318 36.5082C52.3455 36.5082 55.0455 35.2877 57.3757 32.6986C57.4497 32.5876 57.5237 32.3287 57.5606 32.1068V5.55028Z"
                  fill="#1CB3B8" />
                <rect x="6.59985" y="8.97656" width="5.85745" height="55.1768" rx="2.92873"
                  transform="rotate(-22.4017 6.59985 8.97656)" fill="#386FC6" />
              </svg>
            </template>
          </about-item>
          <about-item title="使命" value="护航数字世界，助力健康中国">
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" :width="icon" :height="icon" viewBox="0 0 64 64" fill="none">
                <path
                  d="M57.1924 6.32693C57.8359 6.7884 58.0894 7.41236 57.9724 8.17931L50.5434 52.7469C50.4459 53.3059 50.1339 53.7414 49.6139 54.0534C49.3474 54.2028 49.042 54.2873 48.717 54.2873C48.5025 54.2873 48.2685 54.2353 48.0215 54.1378L34.8794 48.7692L27.8533 57.3356C27.5023 57.7841 27.0279 57.9986 26.4299 57.9986C26.1829 57.9986 25.9684 57.9596 25.7864 57.8816C25.4225 57.7451 25.1235 57.5241 24.9025 57.1992C24.6815 56.8807 24.5645 56.5297 24.5645 56.1397V46.0199L49.6334 15.2899L18.6174 42.1331L7.15865 37.4339C6.44369 37.1674 6.05372 36.6345 6.00172 35.835C5.96272 35.0616 6.2682 34.4896 6.93116 34.1191L55.2101 6.26194C55.5025 6.08645 55.808 6.00195 56.1395 6.00195C56.5295 6.00195 56.8804 6.11245 57.1924 6.32693Z"
                  fill="#1CB3B8" />
                <path
                  d="M57.1924 6.32693C58.5183 9.12175 55.9185 11.2016 50.1989 15.8813L18.6174 42.1331L7.15865 37.4339C6.44369 37.1674 6.05372 36.6345 6.00172 35.835C5.96272 35.0616 6.2682 34.4896 6.93116 34.1191L55.2101 6.26194C55.5025 6.08645 55.808 6.00195 56.1395 6.00195C56.5295 6.00195 56.8804 6.11245 57.1924 6.32693Z"
                  fill="#386FC6" />
              </svg>
            </template>
          </about-item>
          <about-item title="价值观" value="客户第一、合作共赢、创新、进取、专业、担当">
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" :width="icon" :height="icon" viewBox="0 0 64 64" fill="none">
                <path
                  d="M21.5511 24.2112L31.7617 57.2095C31.7718 57.2426 31.7924 57.2716 31.8202 57.2922C31.8481 57.3127 31.8818 57.3238 31.9164 57.3238C31.9511 57.3238 31.9848 57.3127 32.0126 57.2922C32.0405 57.2716 32.061 57.2426 32.0712 57.2095L42.2853 24.2112H21.5511ZM23.7344 6.68164H14.925C13.9585 6.68149 13.007 6.92057 12.1553 7.37755C11.3037 7.83453 10.5784 8.49522 10.0441 9.30065L3.10374 19.741C3.04182 19.8343 3.00633 19.9427 3.00106 20.0546C2.99578 20.1665 3.0209 20.2777 3.07376 20.3765C3.12663 20.4753 3.20525 20.5579 3.30129 20.6156C3.39733 20.6732 3.50719 20.7038 3.61921 20.7041H17.6666L23.7344 6.68164ZM42.083 20.7041L36.0116 6.68164H27.8332L21.7618 20.7064H42.0949L42.083 20.7041ZM13.6143 36.2669C13.6381 36.2574 27.0165 52.6953 30.195 56.6047C30.2193 56.6354 30.2539 56.6561 30.2923 56.6633C30.3308 56.6704 30.3705 56.6634 30.4042 56.6435C30.4378 56.6236 30.4632 56.5922 30.4755 56.5551C30.4878 56.518 30.4863 56.4777 30.4712 56.4417L17.5619 24.2135H4.67396C4.55514 24.2124 4.4385 24.2455 4.33799 24.3089C4.23748 24.3723 4.15733 24.4633 4.10712 24.571C4.05691 24.6787 4.03876 24.7986 4.05483 24.9163C4.07091 25.034 4.12053 25.1447 4.19778 25.235L13.6119 36.2705L13.6143 36.2669ZM40.0949 6.68164L46.1722 20.7041H60.3803C60.4929 20.704 60.6033 20.6732 60.6997 20.6151C60.7962 20.557 60.875 20.4738 60.9277 20.3743C60.9805 20.2749 61.0051 20.1629 60.9991 20.0505C60.993 19.9381 60.9565 19.8295 60.8934 19.7362L53.7852 9.25303C53.2485 8.46093 52.526 7.81238 51.6807 7.36411C50.8354 6.91585 49.8932 6.68152 48.9364 6.68164H40.0949ZM54.928 30.917C54.9042 30.9051 58.1661 27.1075 59.7791 25.235C59.8566 25.1446 59.9064 25.0338 59.9226 24.9158C59.9388 24.7979 59.9208 24.6777 59.8705 24.5698C59.8203 24.4618 59.7401 24.3706 59.6395 24.307C59.5388 24.2434 59.422 24.2101 59.3029 24.2112H46.2722L33.1962 56.569C33.1813 56.6049 33.1799 56.645 33.1921 56.6818C33.2044 56.7187 33.2294 56.7499 33.2628 56.7699C33.2961 56.7898 33.3355 56.797 33.3738 56.7903C33.412 56.7836 33.4466 56.7634 33.4712 56.7333L54.928 30.917Z"
                  fill="#1CB3B8" />
                <path
                  d="M21.551 24.2112L31.7616 57.2095C31.7718 57.2426 31.7923 57.2716 31.8201 57.2922C31.848 57.3127 31.8817 57.3238 31.9164 57.3238C31.951 57.3238 31.9847 57.3127 32.0126 57.2922C32.0404 57.2716 32.0609 57.2426 32.0711 57.2095L42.2853 24.2112H21.551ZM42.0829 20.7041L36.0115 6.68164H27.8331L21.7617 20.7064H42.0948L42.0829 20.7041Z"
                  fill="#386FC6" />
              </svg>
            </template>
          </about-item>
        </div>
      </div>
      <div class="info">
        <p>
          智先生科技成立于2019年，致力于成为行业领先的数智化解决方案商，提供智慧运营、智慧医保、智慧服务、智能运维等数字化解决方案，助推行业数字化转型升级。目前已获评国家高新技术企业、江苏省“专精特新”中小企业、江苏省软件核心竞争力企业（创新型）等资质。
        </p>
        <p>
          目前已申请国家发明专利、软件著作权、产品认证等200余项，主持、参与市级重点研发计划2项，获批市级企业工程技术研究中心，为400多家行业客户提供产品、服务与解决方案。
        </p>
      </div>
      <div class="partners" id="partners">
        <h1>
          用户案例
          <span>400+</span>
        </h1>
        <Partners />
      </div>
      <div class="history" id="history">
        <h1>发展历程</h1>
        <Timeline />
      </div>
    </div>
  </div>
</template>
<script>
import TopBg from "../common/TopBg.vue";
import AboutItem from "../common/about-item.vue";
import Partners from "../common/partners.vue";
import Timeline from "../common/timeline.vue";

export default {
  name: "About",
  components: {
    TopBg,
    AboutItem,
    Partners,
    Timeline,
  },
  data() {
    return {
      topBg: require("../../assets/aboutBg.png"),
    };
  },
  computed: {
    icon() {
      return window.innerWidth <= 1000 ? 20 : 64;
    },
  },
  mounted() {
    this.scrollToAnchor();
  },
  watch: {
    $route() {
      this.scrollToAnchor();
    },
  },
  methods: {
    scrollToAnchor() {
      const hash = this.$route.hash;
      if (hash) {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    },
  },
};
</script>

<style scoped>
.free-cntainer {
  background: #f6f8fd;
}

.main-content {
  margin-top: -235px;
  padding-bottom: 16px;
}

h1 {
  color: #1f2329;
  text-align: left;
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 65px;
}

h1 span {
  color: #1cb3b8;
  font-weight: 600;
}

.rows-3 {
  margin-bottom: 64px;
}

.info {
  border-radius: 8px 0px 0px 8px;
  border: 1px solid #d9dbdf;
  background: linear-gradient(8deg, #f8faff 0%, #d1d9ec 100%);
  padding: 32px;
  margin-bottom: 80px;
}


@media screen and (max-width: 1000px) {
  .info {
    padding: 8px;
    margin-bottom: 32px;
  }
}

.info p {
  color: #50627f;
  text-align: justify;
  font-family: "PingFang SC";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%;
  letter-spacing: -0.72px;
}

.info p:first-child {
  margin-bottom: 14px;
}

.partners {
  margin-bottom: 80px;
}

.history h1,
.partners h1 {
  margin-bottom: 32px;
}
</style>